import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { ButtonComponent } from '@shared/components/button/button.component';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { TranslateModule } from '@ngx-translate/core';
import { E_CONTENT_TYPE, E_FOLDER_TYPES } from '@shared/constants/enums.const';
import { RouterLink } from '@angular/router';
import { HelperService } from '../../../services/helper.service';

@Component({
  selector: 'app-see-all',
  imports: [
    ButtonComponent,
    TranslateModule,
    RouterLink,
  ],
  templateUrl: './see-all.component.html',
  styleUrl: './see-all.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeeAllComponent {
  relatedId = input<number>();
  contentType = input<E_CONTENT_TYPE>();
  showSeeAllButton = input<boolean>(true);
  seeAllText = input<string>('See all related');
  showCategories = input<boolean>(true);
  url = input<string>('');
  isRelatedPublications = input<boolean>(false);
  disabled = input<boolean>(false);

  relatedUrl = computed(() => {
    if (this.isRelatedPublications()) {
      return this.HELPER.getUrl(`${E_FOLDER_TYPES.RelatedPublications}`);
    } else {
      return this.HELPER.getUrl(`${E_FOLDER_TYPES.Related}/${this.relatedId()}`);
    }

  });
  relatedParams = computed(() => {
    return {
      'content-type': this.contentType(),
      'show-categories': this.showCategories(),
    };
  });
  protected readonly BUTTON_TYPES = BUTTON_TYPES;
  protected readonly E_FOLDER_TYPES = E_FOLDER_TYPES;


  private HELPER: HelperService = inject(HelperService);


}
